export enum TravelMethod {
  NXBus = 'NX Bus',
  NXBusMetroTram = 'NX Bus & Metro tram',
  NBus = 'nBus',
  NBusMetroTram = 'nBus & Metro tram',
  NNetwork = 'nNetwork',
  WestMidlandsMetro = 'West Midlands Metro tram',
}

export const TravelMethodMap: Record<TravelMethod, string> = {
  [TravelMethod.NBus]: 'travel_method_n_bus',
  [TravelMethod.NBusMetroTram]: 'travel_method_n_bus_metro',
  [TravelMethod.NNetwork]: 'travel_method_n_network',
  [TravelMethod.NXBus]: 'travel_method_nx_bus',
  [TravelMethod.NXBusMetroTram]: 'traveL_method_nx_bus_metro',
  [TravelMethod.WestMidlandsMetro]: 'travel_method_west_midlands_metro',
};

export function getTravelMethodKey(
  maybeTravelMehod: string | undefined
): string | undefined {
  return maybeTravelMehod
    ? TravelMethodMap[maybeTravelMehod as unknown as TravelMethod]
    : undefined;
}
